<template>
  <button type="button" class="quick" @click.prevent="$emit('click')" :class="{ 'has-icon': r.icon }" :style="{ color: r.color, 'background-color': r.fill  }">
    <icon class="quick-icon2" v-if="r.icon" :name="r.icon || 'custom'" :bg="r.color" :fill="r.fill || 'white'" />
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    big: Boolean,
    r: null
  }
}
</script>

<style>
.quick {
  position: relative;
  margin: 0.5em;
  border: none;
  box-shadow: none;
  border-radius: 32px;
  line-height: 20px;
  padding: 10px 18px;
  background: #fff;
  color: #005ba9;
  outline: none;
  display: inline-block;
  box-sizing: border-box;
  font: inherit;
  -webkit-font-smoothing: unset;
  -moz-osx-font-smoothing: unset;
}
.quick + .quick {
  margin-left: 0.5em;
}
.quick.has-icon {
  padding-left: 50px;
}
.quick-icon2.icon {
  position: absolute;
  left: 4px;
  top: 4px;
  bottom: 4px;
  height: 32px;
  width: 32px;
  padding: 7px;
  border-radius: 32px;
  font-size: 18px;
  box-sizing: border-box;
}
.quick--big {
  padding: 0!important;
  width: 64px;
  height: 64px;
  opacity: .4;
  pointer-events: none;
}
.quick--big>.quick-icon2 {
  font-size: 48px;
  height: 56px;
  width: 56px;
}
.quick--big>.quick-title {
  display: none;
}
.quick--big:hover {
  opacity: 1;
}
.focus .quick--big {
  transition: opacity .2s;
  pointer-events: auto;
}
</style>
